import React from 'react';
import Navigation from '../components/layout/Navigation';
import Hero from '../components/landing/Hero';
import Features from '../components/landing/Features';
import HowItWorks from '../components/landing/HowItWorks';

const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation isAuthenticated={false} />
      <Hero />
      <Features />
      <HowItWorks />

      {/* Simple Footer */}
      <footer className="bg-rowing-navy text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-2xl font-display font-bold">GLYYD</h3>
              <p className="mt-2 text-rowing-gray-300">Your path to college rowing success.</p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Platform</h4>
              <ul className="space-y-2 text-rowing-gray-300">
                <li>
                  <button className="hover:text-white text-left">Features</button>
                </li>
                <li>
                  <button className="hover:text-white text-left">Schools</button>
                </li>
                <li>
                  <button className="hover:text-white text-left">Success Stories</button>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-rowing-gray-300">
                <li>
                  <a href="/about" className="hover:text-white">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="/pricing" className="hover:text-white">
                    Pricing
                  </a>
                </li>
                <li>
                  <button className="hover:text-white text-left">Contact</button>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Legal</h4>
              <ul className="space-y-2 text-rowing-gray-300">
                <li>
                  <a href="/privacy" className="hover:text-white">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/terms" className="hover:text-white">
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a href="/cookies" className="hover:text-white">
                    Cookie Policy
                  </a>
                </li>
                <li>
                  <a href="/coppa-rights" className="hover:text-white">
                    COPPA Rights
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-rowing-gray-700">
            <div className="flex flex-col md:flex-row items-center justify-between">
              <p className="text-rowing-gray-400">&copy; 2025 GLYYD. All rights reserved.</p>
              <div className="flex items-center space-x-6 mt-4 md:mt-0">
                <div className="flex items-center space-x-2 text-rowing-gray-400">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-sm">COPPA Compliant</span>
                </div>
                <div className="flex items-center space-x-2 text-rowing-gray-400">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-sm">SSL Secured</span>
                </div>
                <div className="flex items-center space-x-2 text-rowing-gray-400">
                  <span className="text-sm font-medium">14+</span>
                  <span className="text-sm">Age Verified</span>
                </div>
              </div>
            </div>
            <div className="mt-4 text-center text-xs text-rowing-gray-500">
              <p>
                Protected by Cloudflare • Monitored by Sentry •
                <a href="/privacy#security" className="hover:text-rowing-gray-300 ml-1">
                  Security Details
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
